<template>
  <div class="d-flex mt-2 sticky-box justify-center">
    <v-btn
      @click="deactivateErrorValidations()"
      class="link non-text-transformation"
      large
      tile
      outlined
    >
      {{
        evaluatorActiveValidations
          ? $t('STICKYBOX_BUTTON_VALIDATIONS_TURN_OFF')
          : $t('STICKYBOX_BUTTON_VALIDATIONS_TURN_ON')
      }}
    </v-btn>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import { GET_OFFER_ITEM } from '@/store/modules/offer/getters'

export default {
  name: 'ActivateValidationsButton',
  computed: {
    ...mapGetters('offer', [GET_OFFER_ITEM]),
    ...mapState('process', ['evaluatorActiveValidations']),
    step() {
      return this[GET_OFFER_ITEM]('step')
    },
  },
  methods: {
    ...mapMutations('process', ['setEvaluatorActiveValidations']),
    deactivateErrorValidations() {
      this.setEvaluatorActiveValidations(!this.evaluatorActiveValidations)
      this.$emit('updateErrors')
    },
  },
}
</script>
